
import { handleActions } from 'redux-actions';

import { COLLABORATOR_ACTION_TYPES } from './constants';
import CollaboratorState from './CollaboratorState';

import type { Action } from '../types';
import type {
  ReceiveCollaboratorPayload,
  ReceiveCollaboratorsPayload,
  ReceiveCollaboratorInvitesPayload,
  ReceiveDeletedCollaboratorPayload,
  ReceiveTimelineEventsPayload,
  ReceiveProjectIdPayload,
} from './types';

const initialState = new CollaboratorState({});

const actions = {
  [COLLABORATOR_ACTION_TYPES.FETCH_COLLABORATORS]: fetchCollaborators,
  [COLLABORATOR_ACTION_TYPES.RECEIVE_COLLABORATORS]: receiveCollaborators,
  [COLLABORATOR_ACTION_TYPES.FETCH_COLLABORATOR_INVITES]: fetchCollaboratorInvites,
  [COLLABORATOR_ACTION_TYPES.RECEIVE_COLLABORATOR_INVITES]: receiveCollaboratorInvites,
  [COLLABORATOR_ACTION_TYPES.DELETE_COLLABORATOR_INVITE]: deleteCollaboratorInvite,
  [COLLABORATOR_ACTION_TYPES.RECEIVE_DELETED_COLLABORATOR_INVITE]: receiveDeletedCollaboratorInvite,
  [COLLABORATOR_ACTION_TYPES.CREATE_COLLABORATOR]: createCollaborator,
  [COLLABORATOR_ACTION_TYPES.RECEIVE_COLLABORATOR]: receiveCollaborator,
  [COLLABORATOR_ACTION_TYPES.CREATE_PROJECT]: createProject,
  [COLLABORATOR_ACTION_TYPES.FETCH_TIMELINE_EVENTS]: fetchTimelineEvents,
  [COLLABORATOR_ACTION_TYPES.RECEIVE_TIMELINE_EVENTS]: receiveTimelineEvents,
  [COLLABORATOR_ACTION_TYPES.CREATE_TIMELINE_EVENT]: createTimelineEvent,
  [COLLABORATOR_ACTION_TYPES.RECEIVE_PROJECT_ID]: receiveProjectId,
};

function fetchCollaborators(state: CollaboratorState): CollaboratorState {
  return state
    .setIsFetchingCollaborators(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveCollaborators(state: CollaboratorState, { payload }: Action<ReceiveCollaboratorsPayload>): CollaboratorState {
  if (!payload) {
    return state;
  }
  return state
    .setCollaborators(payload.collaborators)
    .setIsFetchingCollaborators(false);
}

function createCollaborator(state: CollaboratorState): CollaboratorState {
  return state.setIsCreatingCollaborator(true);
}

function createProject(state: CollaboratorState): CollaboratorState {
  // return state.setIsCreatingProject(true);
  //TODO
}

function receiveCollaborator(state: CollaboratorState, { payload }: Action<ReceiveCollaboratorPayload>): CollaboratorState {
  if (!payload) {
    return state;
  }
  return state
    .setIsCreatingCollaborator(false);
}

function fetchCollaboratorInvites(state: CollaboratorState): CollaboratorState {
  return state.setIsFetchingInvites(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveCollaboratorInvites(state: CollaboratorState, { payload }: Action<ReceiveCollaboratorInvitesPayload>): CollaboratorState {
  if (!payload) {
    return state;
  }
  return state
    .setInvites(payload.invites)
    .setIsFetchingInvites(false);
}

function deleteCollaboratorInvite(state: CollaboratorState): CollaboratorState {
  return state.setIsFetchingInvites(true);
}

function receiveDeletedCollaboratorInvite(state: CollaboratorState, { payload }: Action<ReceiveDeletedCollaboratorPayload>): CollaboratorState {
  if (!payload) {
    return state;
  }
  return state
    .removeInviteById(payload.id)
    .setIsFetchingInvites(false);
}

function fetchTimelineEvents(state: CollaboratorState): CollaboratorState {
  // return state.setIsFetchingEvents(true); // TODO
}

function receiveTimelineEvents(state: CollaboratorState, { payload }: Action<ReceiveTimelineEventsPayload>): CollaboratorState {
  if (!payload) {
    return state;
  }
  return state.setEvents(payload.timelineEvents);
  // .setIsFetchingEvents(false) // TODO
}

function createTimelineEvent(state: CollaboratorState): CollaboratorState {
  return state.setIsCreatingEvent(true);
}

function receiveProjectId(state: CollaboratorState, { payload }: Action<ReceiveProjectIdPayload>): CollaboratorState {
  if (!payload) {
    return state;
  }
  return state.setProjectId(payload.projectId);
}


export default handleActions(actions, initialState);



// WEBPACK FOOTER //
// ./src/redux/collaborators/reducer.js